<template>
  <div class="header">
    <div class="title" v-text="text"></div>
  </div>
</template>

<script>
export default {
  name: 'GSHeader',
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.header {
  background-image: url('https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/img_title.png');
  width: 100%;
  height: $base-size * 90;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center top;

  .title {
    color: #AEBBD2;
    text-align: center;
    font-size: $font-size-l;
    line-height: $base-size * 90;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSHeader.vue